/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { Check, Heart, MapPin } from 'react-feather'
import Moment from 'react-moment'
import { Link } from 'react-router-dom'
import { Card, CardBody } from 'reactstrap'
import dummy from '../../assets/images/bg2.png'
import { useTranslation } from 'react-i18next'

const JobHistoryCard = ({ item, setId = null }) => {
    const { t } = useTranslation()
    console.log(item)
    return (
        <>
            <Card className="job-box job-primary h-100 rounded-4 px-0 shadow_2 border-0 overflow-hidden">
                <CardBody className="content position-relative px-sm-4 px-3">
                    <div className='d-flex justify-content-between gap-3'>
                        <Link to={`/job-detail/${item?.postJob?._id}`} state={item?.postJob} className="d-flex gap-sm-3 gap-2 link-dark  ">
                            <div className="position-relative">
                                <img src={item?.postJob?.image?.length > 0 ? global.BASEURL + "/" + item?.postJob?.image[0] : dummy} className="img1 bg-secondary" alt="" />
                            </div>
                            <div>
                                <h5 className='mb-0 mt-1' style={{ fontWeight: 600 }}>
                                    {item?.postJob?.title}
                                </h5>
                                <p className="text-muted mb-0">
                                    <span className="text-muted fs_08">
                                        {item?.category?.name}
                                    </span>
                                </p>
                                <p className="text-muted mb-1">
                                    <span className="text-muted fs_08">
                                        <MapPin className="fea icon-sm" />{' '}
                                        {item?.postJob?.address}
                                    </span>
                                </p>
                                <>
                                    {item?.shortlist === "shortlist" && <span className='align-middle btn-pills py-1 px-3 btn-success btn ms-1' style={{ fontSize: "10px", whiteSpace: 'nowrap' }}>{t('appli_drop6')} </span>}
                                    {item?.shortlist === "reject" && <span className='align-middle btn-pills py-1 px-3 btn-danger btn ms-1' style={{ fontSize: "10px", whiteSpace: 'nowrap' }}>{t('appli_drop2')}</span>}
                                    {item?.shortlist === "none" && <span className='align-middle btn-pills py-1 px-3 btn-info btn ms-1' style={{ fontSize: "10px", whiteSpace: 'nowrap' }}>{item?.shortlist}</span>}
                                </>
                                <>
                                    {item?.interviewOutcome === "offerPosition" && <span className='align-middle btn-pills py-1 px-3 btn-success btn ms-1' style={{ fontSize: "10px", whiteSpace: 'nowrap' }}>{t('offer_Position')}</span>}
                                    {item?.interviewOutcome === "decisionNeeded" && <span className='align-middle btn-pills py-1 px-3 btn-warning btn ms-1' style={{ fontSize: "10px", whiteSpace: 'nowrap' }}>{t('decision_Needed')}</span>}
                                    {item?.interviewOutcome === "rejectCandiate" && <span className='align-middle btn-pills py-1 px-3 btn-danger btn ms-1' style={{ fontSize: "10px", whiteSpace: 'nowrap' }}>{t('reject_Candiate')}</span>}
                                </>
                            </div>
                        </Link>
                    </div>
                    <Link to={`/job-detail/${item?.postJob?._id}`} state={item?.postJob} className="d-flex gap-3 link-dark  ">

                        <div className='d-flex flex-column justify-content-between h-100'>
                            <div>
                                <div className="company-detail mt-1">
                                    <h6 className="mb-0">
                                        <span dangerouslySetInnerHTML={{ __html: item?.postJob?.description }}
                                            className="text-dark jobData2 two-line-ellipsis company-name fs_09 text-muted">
                                        </span>
                                    </h6>
                                </div>
                                <Moment format='ll' className='fs_09 mt-1 text-secondary'>
                                    {item?.postJob?.createdAt}
                                </Moment>
                            </div>
                        </div>
                    </Link>
                </CardBody>
            </Card>
        </>
    )
}

export default JobHistoryCard